import { FunctionComponent } from "react";
import { StyledIndicator } from "./indicator.styles";

interface IndicatorProps {
  children: any;
  type: "positive" | "negative";
}

const Indicator: FunctionComponent<IndicatorProps> = ({ children, type }) => {
  return <StyledIndicator $type={type}>{children}</StyledIndicator>;
};

export default Indicator;
